import type { AxiosRequestConfig } from 'axios'

import { http } from '@/lib/api-client'
import type { ApiResponse, PaginatedResponse } from '@/types/api'

export { http }

export const api = {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    return http.get<ApiResponse<T>>(url, config).then((response) => response.data)
  },

  post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    return http.post<ApiResponse<T>>(url, data, config).then((response) => response.data)
  },

  put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    return http.put<ApiResponse<T>>(url, data, config).then((response) => response.data)
  },

  patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    return http.patch<ApiResponse<T>>(url, data, config).then((response) => response.data)
  },

  delete<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    return http.delete<ApiResponse<T>>(url, config).then((response) => response.data)
  },
}

export function getPaginated<T>(url: string, config?: AxiosRequestConfig): Promise<PaginatedResponse<T>> {
  return http.get<PaginatedResponse<T>>(url, config).then((response) => response.data)
}

export function unwrap<T>(response: ApiResponse<T>): T {
  return response.data
}

